import upperFirst from "lodash/upperFirst";
import { devLogger } from "./debug";

export const reduceModelActions = (props) => {
  const { keys, action, resource, data, actionsMap } = props;
  const actions = [];
  keys.forEach((modelKey) => {
    /**
     * Example values for assoc action key construction
     * 1. action - set
     * 2. resource - user
     * 3. modelKey - merchantAccounts
     */

    /**
     * Process model
     */
    const models = data[modelKey];
    const actionKey = `${action}${upperFirst(modelKey)}`;
    devLogger(`models ${actionKey}`, models);

    const modelAction = actionsMap[actionKey];
    if (!modelAction) {
      throw new Error(`No action registered for ${actionKey}`);
    }
    if (models && modelAction) {
      actions.push(modelAction(models));
    }

    /**
     * Process associations
     */
    const assocModelKey = `${resource}${upperFirst(modelKey)}`;
    const assocModels = data[assocModelKey];
    const assocActionKey = `${action}${upperFirst(resource)}${upperFirst(
      modelKey
    )}`;

    const assocAction = actionsMap[assocActionKey];
    if (!assocAction) {
      throw new Error(`No assoc action registered for ${assocActionKey}`);
    }

    if (assocModels && assocAction) {
      devLogger(`assocModels ${assocActionKey}`, assocModels);
      actions.push(assocAction(assocModels));
    }
  });

  return actions;
};

export const NO_OP = () => {};
